module.exports = __webpack_public_path__ + "static/media/header-burger.5e68ec3d.svg";